// @flow

import React, {useEffect, useState} from 'react';
import {
  FormControlLabel,
  Typography,
  debounce,
  makeStyles,
} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';

import {useTypedSelector} from '../../../../../store';
import {useBindedActions} from '../../../../../utils/globalStore';

import {actions as ProductFilterActions} from '../../../duck';
import {useIsFeatureInTier} from '../../../../../utils/component';
type Props = {};

const useStyles = makeStyles(theme => ({
  editBtn: {
    color: colors.grey700,
  },
  card: {
    width: '100%',
    maxWidth: '100%',
    boxShadow: '0px 0.5px 2px 0px #60617029',
    padding: theme.spacing(1, 2, 2, 2),
    backgroundColor: '#FFFFFF',
    display: 'flex',
    gap: theme.spacing(1),
    borderRadius: 12,
    border: `1px solid ${colors.grey300}`,
    flexDirection: 'column',
  },
  divider: {
    backgroundColor: colors.grey300,
  },
  title: {
    fontWeight: 600,
    color: colors.grey900,
    fontSize: 16,
  },
  subtitle: {
    color: '#717190',
    fontSize: 14,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  switchLabel: {
    color: colors.grey700,
    fontSize: 14,
  },
}));

const PromotionsFiltersItem = (props: Props) => {
  const classes = useStyles();

  const hasProductFiltersFeature = useIsFeatureInTier('PRODUCT_FILTER');
  const [enabled, setEnabled] = useState<boolean>(false);

  const productFiltersSetting = useTypedSelector(
    state => state.productFilters.productFiltersSetting
  );
  const {saveProductFilterSetting} = useBindedActions(ProductFilterActions);

  const handleEnable = debounce(checked => {
    saveProductFilterSetting({
      productFilterSettingRequest: {
        promotionFilter: {
          enabled: checked,
        },
      },
    });
  }, 300);

  useEffect(() => {
    if (productFiltersSetting?.promotionFilter) {
      const {enabled} = productFiltersSetting.promotionFilter;
      setEnabled(enabled);
    }
  }, [productFiltersSetting]);

  const action = (
    <FormControlLabel
      control={
        <IosSwitch
          disabled={!hasProductFiltersFeature}
          defaultChecked={enabled}
          checked={enabled}
          onChange={e => handleEnable(e.target.checked)}
        />
      }
      classes={{label: classes.switchLabel}}
      labelPlacement="start"
      label={enabled ? 'Activado' : 'Desactivado'}
    />
  );

  return (
    <div className={classes.card}>
      <div className={classes.actions}>
        <Typography className={classes.title}>Promociones</Typography>
        {action}
      </div>
      <Typography className={classes.subtitle}>
        Activa esta opción para que tu cliente pueda filtrar productos por
        promoción activa.
      </Typography>
    </div>
  );
};

export default PromotionsFiltersItem;
